'use client';

import * as React from 'react';

export function useStableId(providedId?: string): string {
	const generatedId = React.useId();
	return providedId ?? generatedId;
}
